import React from "react";
import { BlockStack, Icon, InlineStack, Text } from "@shopify/polaris";
import { StarFilledIcon } from "@shopify/polaris-icons";

function ReviewDetails({ data }) {
  const { rating } = data;
  const reviewRating = parseInt(rating);
  const starTone = reviewRating < 5 ? "critical" : "warning";

  return (
    <div className="my-1 star-ratings">
      <BlockStack gap={"050"}>
        {reviewRating ? (
          <BlockStack gap={"050"}>
            <Text> Rating:</Text>
            <InlineStack gap={0} align="start">
              {[...Array(reviewRating)].map((_, i) => (
                <Icon key={i} source={StarFilledIcon} tone={starTone} />
              ))}
            </InlineStack>
          </BlockStack>
        ) : (
          <Text>No review</Text>
        )}
      </BlockStack>
    </div>
  );
}
export default ReviewDetails;
